/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GamePbpModelDto } from '../../models/game-pbp-model-dto';

export interface GameTrackerControllerUpdateGameLocalConnectionInfo$Params {
  uuid: string;
  localConnectionInfo: string;
}

export function gameTrackerControllerUpdateGameLocalConnectionInfo(http: HttpClient, rootUrl: string, params: GameTrackerControllerUpdateGameLocalConnectionInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<GamePbpModelDto>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerControllerUpdateGameLocalConnectionInfo.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.query('localConnectionInfo', params.localConnectionInfo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GamePbpModelDto>;
    })
  );
}

gameTrackerControllerUpdateGameLocalConnectionInfo.PATH = '/game-tracker/games/{uuid}/local-connection-info';
